import { Download, FileText } from "@tamagui/lucide-icons";

import { useCreateAttachmentLink } from "@/api/generated";
import { AttachmentContent } from "@/api/generated/models";
import { Button } from "@/components";
import ChatNote from "@/components/ChatNote";
import { downloadMessageFile } from "@/utils/downloadMessageFile";
import type { CuraiMessageProps } from ".";

const ATTACHMENT_MIME_TYPES = ["application/pdf"] as const;

type AttachmentMimeType = (typeof ATTACHMENT_MIME_TYPES)[number];

type AttachmentProps = Omit<CuraiMessageProps, "content"> & {
  content: AttachmentContent;
};

export default function Attachment({ content, messageId }: AttachmentProps) {
  const { refetch, isFetching } = useCreateAttachmentLink(messageId!, {
    query: {
      enabled: false,
      gcTime: 0,
    },
  });

  const attachmentDescription = () => {
    switch (content.content_type as AttachmentMimeType) {
      case "application/pdf":
        return "PDF document";
      default:
        return "Unknown";
    }
  };

  return (
    <ChatNote.Active
      title={content.title}
      Icon={FileText}
      subtitle={attachmentDescription()}
      marginVertical="$100"
      button={
        <Button
          mode="primary"
          icon={Download}
          disabled={isFetching}
          onPress={() =>
            downloadMessageFile({
              messageId: messageId!,
              path: "attachment",
              fetchKey: refetch,
            })
          }
        >
          Download
        </Button>
      }
    />
  );
}
